<template>
    <div class="news-container">
        <div v-if="props.data && props.data.length > 0" class="news-content">
            <ul class="news-list">
                <li class="first-common-news-item" @click="goDetail(props.data[0])" v-link="getDetailLink(props.data[0])">
                    <LazyImage :src="props.data[0].coverUrl || defaultNewsImg" class-name="news-img"/>
                    <div class="right-wrap">
                        <p class="news-title">{{props.data[0].contentTitle}}</p>
                        <div class="new-date-detail">
                            <p>{{props.data[0].publishTime}}</p>
                            <p>详情</p>
                        </div>
                    </div>
                </li>
                <li class="common-news-item" v-for="item in props.data.slice(1, 4)" :key="item.contentId" @click="goDetail(item)">
                    <p class="news-text overflow-ellipsis" :title="item.contentTitle">
                        <span v-link="getDetailLink(item)">{{item.contentTitle}}</span>
                    </p>
                    <p class="light-gray-font-color">{{item.publishTime}}</p>
                </li>
            </ul>
        </div>
        <BigNoData
            class="mar-top49"
            v-else
            url="no-news@2x.png"
            info="暂无资讯，静等上新"/>
    </div>
</template>

<script setup>
import BigNoData from '@/components/no-data.vue';
import LazyImage from '@/components/lazy-image/lazy-image.vue';
import { goNewsDetail, getLink } from '@/lib/tools.js';

const defaultNewsImg = 'https://srt-read-online.3ren.cn/basebusiness/material/20221102/16673627738023vUnoocsyi002.jpg'

const props = defineProps({
    data: { // 新闻咨询列表
        type: Array,
        default: () => []
    }
})

// 跳转新闻详情页
function goDetail (info) {
    goNewsDetail(info, 'informationDetail');
}

function getDetailLink(info){
    return getLink(info, 'informationDetail');
}
</script>

<style lang="scss" scoped>
.news-container {
    margin-top: 20px;
    .news-content {
        .news-list {
            .first-common-news-item {
                display: flex;
                margin-bottom: 20px;
                cursor: pointer;
                .news-img {
                    width: 280px;
                    height: 157px;
                    border-radius: 4px;
                }
                .right-wrap {
                    flex: 1;
                    margin-left: 20px;
                    border-bottom: 1px solid #EFF0F2;
                    .news-title {
                        height: 48px;
                        font-size: 16px;
                        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                        font-weight: bold;
                        color: #222222;
                        line-height: 24px;
                        word-break: break-all;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2; /* 这里是超出几行省略 */
                        overflow: hidden;
                        margin-top: 8px;
                        &:hover {
                            color: var(--srt-main-active-text-color);
                        }
                        &::before {
                            content: '\e6e7';
                            font-size: 18px;
                            font-family: 'iconfont';
                            color: #FF4719;
                            margin-right: 4px;
                        }
                    }
                    .new-date-detail {
                        margin-top: 61px;
                        display: flex;
                        justify-content: space-between;
                        p {
                            color: var(--srt-color-light-gray);
                            width: 100%;
                        }
                        p:nth-child(2) {
                            text-align: right;
                            color: var(--srt-main-active-text-color);
                        }
                    }
                }
            }
            .common-news-item {
                cursor: pointer;
                display: flex;
                align-items: center;
                line-height: 19px;
                margin-top: 14px;
                &::before {
                    content: '';
                    display: inline-block;
                    background: #91A5BA;
                    width: 0;
                    height: 0;
                    border: 3px solid #91A5BA;
                    margin-right: 10px;
                    border-radius: 6px;
                }
                .news-text {
                    width: 100%;
                    margin-right: 70px;
                    color: var(--srt-main-text-color);
                }
                &:hover {
                    .news-text {
                        color: var(--srt-main-active-text-color);
                    }
                    &::before {
                        background: var(--srt-main-active-text-color);
                    }
                }
            }
        }
    }
    .mar-top49 {
        margin-top: 49px;
    }
}
</style>